import { useQuery } from "@tanstack/react-query";
import type { ZodSchema } from "zod";
import { FUND_CENTRE_API_PATH } from "../../constants";
import { useSrpApiContext } from "../../provider";
import type { SrpRequestParams } from "../../types";
import useSRP from "../useSRP";

/**
 * Custom hook to fetch fund centre data
 *
 * @param {boolean} enabled - Flag to enable/disable the query
 * @param {Required<Pick<SrpRequestParams, "id"> & Pick<SrpRequestParams, "language" | "audience">} args - Request parameters
 * @param {ZodSchema<T>} [schema] - Optional Zod schema for response validation
 * @param {string} [baseURL] - Optional base URL for the API request
 * @returns {UseQueryResult} Query result containing fund centre data
 * @throws {Error} When used outside of SrpApiContext
 */
export default function useFundCentre<T>(
	enabled: boolean,
	args: Required<Pick<SrpRequestParams, "id">> &
		Pick<SrpRequestParams, "language" | "audience">,
	schema?: ZodSchema<T>,
	baseURL?: string,
) {
	const { id, ..._args } = args;
	return useSRP(
		`${FUND_CENTRE_API_PATH}/${id}`,
		enabled,
		_args,
		schema,
		baseURL,
	);
}
